export enum TableColType {
  Text,
  Date,
  Score,
  Toggle,
  Pills,
  Button,
  Badge,
  Email,
  Currency,
  Links,
  List,
  Icon,
  Ago,
  Avatar,
  // An ITranslatable ({ key, params }) rendered through the `translatable` pipe
  Translatable
}
